/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-select[_ngcontent-%COMP%]{font-size:1rem;padding:2px 20px!important;margin:3px 10px!important}.table[_ngcontent-%COMP%]   caption[_ngcontent-%COMP%]{font-size:1.6em;text-align:center}.table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%]{vertical-align:middle}"];
export { styles as styles };
